import { Trans } from "react-i18next";
import React, { useState } from "react";
import { Modal, Button, Form, Spinner } from "react-bootstrap";
import apiClient from "@shared/services/apiClient";

type Props = {
  show: boolean;
  onHide: () => void;
  perspectiveId: string | null;
  onShared?: (data: any) => void;
};

const ShareModal: React.FC<Props> = ({
  show,
  onHide,
  perspectiveId,
  onShared,
}) => {
  const [scope, setScope] = useState<string>("organization");
  const [recipients, setRecipients] = useState<string>("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleShare = async () => {
    if (!perspectiveId) return;
    setLoading(true);
    setError(null);
    try {
      const payload: any = { scope };
      if (scope === "private") {
        payload.recipients = recipients
          .split(",")
          .map((s) => s.trim())
          .filter(Boolean);
      }

      const resp = await apiClient.post(
        `/perspectives/${perspectiveId}/share`,
        payload,
      );

      if (onShared) onShared(resp?.data || resp?.data?.data || null);
      onHide();
    } catch (err: any) {
      setError(err?.response?.data?.error || err?.message || "Share failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title><Trans ns="features" i18nKey="ui.copy.371452a102bd" /></Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <Form.Group className="mb-3">
            <Form.Label><Trans ns="features" i18nKey="ui.copy.4651a34e4df9" /></Form.Label>
            <Form.Select
              value={scope}
              onChange={(e) => setScope(e.target.value)}
            >
              <option value="organization"><Trans ns="features" i18nKey="ui.copy.519255ae1f74" /></option>
              <option value="private"><Trans ns="features" i18nKey="ui.copy.5644242b7bf3" /></option>
            </Form.Select>
          </Form.Group>

          {scope === "private" && (
            <Form.Group className="mb-3">
              <Form.Label>
                <Trans ns="features" i18nKey="ui.copy.48314f363a1a" /></Form.Label>
              <Form.Control
                as="textarea"
                rows={2}
                value={recipients}
                onChange={(e) => setRecipients(e.target.value)}
                placeholder="alice@example.com, bob@example.com"
              />
            </Form.Group>
          )}

          {error && (
            <div className="alert alert-danger" role="alert">
              {error}
            </div>
          )}
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide} disabled={loading}>
          <Trans ns="features" i18nKey="ui.copy.77dfd2135f4d" /></Button>
        <Button variant="primary" onClick={handleShare} disabled={loading}>
          {loading ? (
            <>
              <Spinner animation="border" size="sm" /> <Trans ns="features" i18nKey="ui.copy.eacf86450768" /></>
          ) : (
            "Share"
          )}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ShareModal;
